import styled from 'styled-components';

import React from 'react';

import { FaCalculator /*, FaRegQuestionCircle*/ } from 'react-icons/fa';

const CalculatorIcon = styled(FaCalculator)`
    margin-left: 0.75rem;
    width: 1rem;
    height: 1rem;
    cursor: pointer;
    transition: color 300ms ease;

    &:hover {
        color: #9ca3af; /* hover:text-gray-400 */
    }
`;

const ModalLabel = ({ label, onClick }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>{label}</span>
            <CalculatorIcon onClick={onClick} />
        </div>
    );
};

export default ModalLabel;
